import APIClient from './client'
import { camelizeKeys } from 'humps'

const getAllFbAdAccounts = () => {
  return APIClient().get(`/v1/fb_ad_accounts`)
    .then( response => camelizeKeys(response.data))
}
const fbAdAccountsAPI = { getAllFbAdAccounts }
export default fbAdAccountsAPI
